import api from './axios';

export type CompanyModel = {
  id: string;
  name: string;
  CNPJ: string;
  groups: Array<Group>;
  values: Value[];
  slogan: string,
  mission: string;
  vision: string;
  logo: string;
  desc: string;
  alternativeText: any;
}

type Group = {
  id: string
  _id: string
  name: string;
  users: Array<string>;
}

type Value = {
  icon: string;
  name: string;
  desc: string;
}

export const getCompany = async (companyId: CompanyModel['id']) => {
  const { data } = await api.get<CompanyModel>(`company/${companyId}`, {});
  return data;
}